import { Controller } from "@hotwired/stimulus"

// Single-select practice autocomplete for the admin Schedule filter form.
// Modeled on states_select_controller, but one selection backed by one scalar
// hidden input, and the surrounding GET form submits itself on select/clear —
// so the selected chip is rendered server-side, not by this controller.
// Declared on the <form>, which lets the date input reuse #submit via
// change->practice-select#submit.
export default class extends Controller {
  static targets = ["input", "results", "hidden"]
  static values = { options: Array } // [[name, id], ...]

  connect() {
    this.options = this.optionsValue.map(([name, id]) => ({ name, id: String(id) }))
  }

  filter() {
    const query = this.inputTarget.value.trim().toLowerCase()
    if (query === "") return this.hideResults()

    this.renderResults(this.options.filter(o => o.name.toLowerCase().includes(query)))
  }

  select(event) {
    this.hiddenTarget.value = event.currentTarget.dataset.id
    this.submit()
  }

  clear(event) {
    event.preventDefault()
    this.hiddenTarget.value = ""
    this.submit()
  }

  submit() {
    this.element.requestSubmit()
  }

  keydown(event) {
    if (event.key === "Escape") this.hideResults()
  }

  closeOnOutside(event) {
    if (!this.element.contains(event.target)) this.hideResults()
  }

  renderResults(matches) {
    this.resultsTarget.innerHTML = ""
    if (matches.length === 0) return this.hideResults()

    matches.slice(0, 8).forEach(o => {
      const row = document.createElement("button")
      row.type = "button"
      row.className = "search-result w-full text-left"
      row.textContent = o.name
      row.dataset.id = o.id
      row.dataset.action = "click->practice-select#select"
      this.resultsTarget.appendChild(row)
    })
    this.resultsTarget.classList.remove("hidden")
  }

  hideResults() {
    this.resultsTarget.classList.add("hidden")
    this.resultsTarget.innerHTML = ""
  }
}
